"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
const react_1 = __importStar(require("react"));
const child_items_1 = require("./child-items");
const styled_1 = require("./styled");
exports.Item = (0, react_1.memo)(({ toggle, item, isOpen = false, parent, isFlat = false, onItemClick = () => null, checkSelection, isLatest }) => {
    const level2 = Boolean(parent);
    const hasChildren = (0, react_1.useMemo)(() => {
        return !!item.children;
    }, [item]);
    const handleItemClick = (0, react_1.useCallback)(() => {
        if (hasChildren) {
            toggle(item);
            item.clickable && onItemClick(item);
        }
        else {
            onItemClick(item);
        }
    }, [toggle, onItemClick, item, hasChildren]);
    const isSelected = (0, react_1.useMemo)(() => {
        if (hasChildren && !item.clickable) {
            return false;
        }
        if (checkSelection) {
            return checkSelection(item);
        }
        return false;
    }, [hasChildren, item, checkSelection]);
    (0, react_1.useEffect)(() => {
        if (parent && isSelected) {
            toggle(parent, true);
        }
    }, [isSelected, toggle, parent]);
    const countElement = (0, react_1.useMemo)(() => {
        if (item.count == null) {
            return null;
        }
        if (typeof item.count === 'function') {
            const Component = item.count;
            return react_1.default.createElement(Component, null);
        }
        else if (typeof item.count === 'object') {
            return item.count;
        }
        else
            return react_1.default.createElement(styled_1.Counter, { className: "counter" }, item.count);
    }, [item.count]);
    const isRenderIcon = Boolean(item.iconLeft);
    const isShowAccordion = hasChildren;
    const isRenderAccordion = isFlat ? false : isShowAccordion || !isRenderIcon;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styled_1.StyledListItem, { disabled: item.disabled, onClick: handleItemClick, divider: false, selected: isSelected, button: true, "$isFlat": isFlat },
            isRenderAccordion && (react_1.default.createElement(styled_1.StyledListItemIcon, null,
                react_1.default.createElement(styled_1.Accordion, { "$hidden": !isShowAccordion, "$isOpen": isOpen, height: "20" }))),
            isRenderIcon && react_1.default.createElement(styled_1.StyledListItemIcon, null, item.iconLeft),
            react_1.default.createElement(styled_1.StyledListItemContent, { "$level2": level2, "$selected": isSelected },
                item.title,
                countElement)),
        !isLatest && item.divider && react_1.default.createElement(styled_1.Divider, { className: "category-list__divider" }),
        !item.disabled && (react_1.default.createElement(child_items_1.ChildItems, { childItems: item.children, isOpen: isOpen, toggle: toggle, parent: item, onItemClick: onItemClick, checkSelection: checkSelection, isLatest: isLatest }))));
});
